/* fowm — page behaviour: header, reveals, builder, buy box, cart drawer, signup and pop-up. */
(() => {
  'use strict';
  const FW = (window.fowm = window.fowm || {});
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };
  const routes = FW.routes || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };
  const url = p => (routes.root === '/' ? '' : routes.root.replace(/\/$/, '')) + p;

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    const fmt = format || FW.moneyFormat || '€{{amount_with_comma_separator}}';
    const n = Number(cents) / 100;
    const group = (num, dec, th, ds) => {
      const parts = num.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.join(ds);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      switch (k) {
        case 'amount': return group(n, 2, ',', '.');
        case 'amount_no_decimals': return group(n, 0, ',', '.');
        case 'amount_with_comma_separator': return group(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(n, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(n, 2, "'", '.');
        case 'amount_with_space_separator': return group(n, 2, ' ', ',');
        default: return group(n, 2, ',', '.');
      }
    }).replace(/<[^>]*>/g, '');
  }
  FW.formatMoney = formatMoney;

  /* ---------- smooth scrolling ---------- */
  let lenis = null;
  if (!reduce && window.Lenis && window.matchMedia('(pointer: fine)').matches) {
    try {
      lenis = new window.Lenis({ lerp: 0.11, wheelMultiplier: 1, smoothWheel: true });
      document.documentElement.classList.add('lenis');
      const raf = t => { lenis.raf(t); requestAnimationFrame(raf); };
      requestAnimationFrame(raf);
    } catch (e) { lenis = null; }
  }
  FW.lenis = lenis;
  document.addEventListener('click', e => {
    const a = e.target.closest('a[href*="#"]');
    if (!a) return;
    const u = new URL(a.href, location.href);
    if (u.pathname !== location.pathname || !u.hash || u.hash === '#') return;
    const t = document.getElementById(decodeURIComponent(u.hash.slice(1)));
    if (!t) return;
    e.preventDefault();
    if (lenis) lenis.scrollTo(t, { offset: t.id === 'how' ? 0 : -76 });
    else window.scrollTo({ top: t.getBoundingClientRect().top + scrollY - (t.id === 'how' ? 0 : 76), behavior: reduce ? 'auto' : 'smooth' });
    history.replaceState(null, '', u.hash);
  });

  /* ---------- header ---------- */
  const nav = $('[data-fw-nav]');
  const darkSecs = $$('.fw-on-dark, .fw-marquee');
  const onScroll = () => {
    if (!nav) return;
    nav.classList.toggle('is-scrolled', scrollY > 12);
    const y = nav.offsetHeight * 0.6;
    nav.classList.toggle('is-over-dark', darkSecs.some(el => { const r = el.getBoundingClientRect(); return r.top <= y && r.bottom >= y; }));
  };
  addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- reveal + parallax + count-up ---------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(es => es.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    }), { rootMargin: '0px 0px -8% 0px' });
    $$('.fw-rise').forEach(el => io.observe(el));
    const co = new IntersectionObserver(es => es.forEach(e => {
      if (!e.isIntersecting) return;
      co.unobserve(e.target);
      const el = e.target, m = el.textContent.match(/^(\D*)(\d+)(.*)$/);
      if (!m || reduce) return;
      const end = +m[2], t0 = performance.now(), dur = 900 + end * 20;
      const step = now => {
        const p = Math.min(1, (now - t0) / dur), k = 1 - Math.pow(1 - p, 3);
        el.textContent = m[1] + Math.round(end * k) + m[3];
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    }), { threshold: 0.6 });
    $$('[data-fw-count]').forEach(el => co.observe(el));
  } else {
    $$('.fw-rise').forEach(el => el.classList.add('is-in'));
  }
  const para = $$('[data-fw-parallax]');
  if (para.length && !reduce) {
    let ticking = false;
    const run = () => {
      ticking = false;
      para.forEach(el => {
        const k = +el.dataset.fwParallax || 0, r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > innerHeight) return;
        el.style.translate = `0 ${(-r.top * k).toFixed(1)}px`;
      });
    };
    addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(run); } }, { passive: true });
    run();
  }

  /* ---------- how it works: pinned progress ---------- */
  const story = $('[data-fw-story]');
  if (story) {
    const bar = $('[data-fw-story-bar]', story), steps = $$('[data-fw-step]', story);
    let lastStep = -1;
    const upd = () => {
      const r = story.getBoundingClientRect(), span = Math.max(1, r.height - innerHeight);
      const p = Math.max(0, Math.min(1, -r.top / span));
      FW.storyP = p;
      if (bar) bar.style.transform = `scaleX(${p.toFixed(4)})`;
      const s = p < 0.36 ? 0 : p < 0.7 ? 1 : 2;
      if (s !== lastStep) { steps.forEach((el, i) => el.classList.toggle('is-on', i === s)); lastStep = s; }
    };
    addEventListener('scroll', upd, { passive: true });
    addEventListener('resize', upd);
    upd();
  }

  /* ---------- radiogroups (builder chips) ---------- */
  function radioGroup(group, onChange) {
    const items = $$('[role="radio"]', group);
    const select = (el, focus) => {
      items.forEach(i => { i.setAttribute('aria-checked', String(i === el)); i.tabIndex = i === el ? 0 : -1; });
      if (focus) el.focus();
      onChange(el.dataset.value);
    };
    items.forEach((el, i) => {
      el.tabIndex = el.getAttribute('aria-checked') === 'true' ? 0 : -1;
      el.addEventListener('click', () => select(el));
      el.addEventListener('keydown', e => {
        const d = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
        if (!d) return;
        e.preventDefault();
        select(items[(i + d + items.length) % items.length], true);
      });
    });
  }

  /* ---------- coffee builder ---------- */
  const builder = $('[data-fw-builder]');
  if (builder) {
    const price = +builder.dataset.price || 2490, servings = +builder.dataset.servings || 20;
    const sub = +builder.dataset.sub || 15, protein = +builder.dataset.protein || 9;
    const state = { drink: 'freddo', scoops: 1, style: 'foam' };
    const NAMES = { freddo: 'Freddo', latte: 'Iced latte', cappuccino: 'Cappuccino', filter: 'Filter coffee' };
    const ICED = { freddo: true, latte: true, cappuccino: false, filter: false };
    const nameEl = $('[data-fw-sum-name]', builder), protEl = $('[data-fw-sum-protein]', builder), textEl = $('[data-fw-sum-text]', builder);
    const render = () => {
      const n = NAMES[state.drink], iced = ICED[state.drink];
      const name = state.style === 'foam' ? `${n} with fowm ${iced ? 'cold foam' : 'foam on top'}` : `${n}, fowm stirred in`;
      const per = price / servings * state.scoops, perSub = price * (100 - sub) / 100 / servings * state.scoops;
      nameEl.textContent = name;
      protEl.textContent = `+${protein * state.scoops} g protein`;
      textEl.textContent = `${state.scoops === 1 ? '1 scoop' : '2 scoops'} of fowm, about ${formatMoney(Math.round(per))} a drink, or ${formatMoney(Math.round(perSub))} with Subscribe & save.`;
      FW.build = Object.assign({}, state);
      document.dispatchEvent(new CustomEvent('fw:build', { detail: FW.build }));
    };
    $$('[data-fw-opt]', builder).forEach(g => radioGroup(g, v => {
      const k = g.dataset.fwOpt;
      state[k] = k === 'scoops' ? +v : v;
      render();
    }));
    render();
  }

  /* ---------- buy box ---------- */
  $$('[data-fw-buy]').forEach(box => {
    const uid = box.dataset.uid;
    let data = {};
    try { data = JSON.parse($(`[data-fw-product-json="${uid}"]`).textContent); } catch (e) {}
    const servings = data.servings || 20;
    const priceEl = $('[data-fw-price]', box), cmpEl = $('[data-fw-compare]', box), perEl = $('[data-fw-per]', box), unitEl = $('[data-fw-unit]', box);
    const addLabel = $('[data-fw-add-label]', box), addPrice = $('[data-fw-add-price]', box);
    const form = $('[data-fw-add-form]', box), msg = $('[data-fw-add-msg]', box);
    const plans = $$('[data-fw-mode]', box);
    let mode = plans.length ? 'sub' : 'once';
    const planPrice = () => {
      const sel = $('input[name="selling_plan"]:checked', box);
      if (sel && data.allocations) {
        const a = data.allocations.find(x => String(x.plan) === sel.value);
        if (a) return a.price;
      }
      return data.subPrice || data.price;
    };
    const update = () => {
      const isSub = mode === 'sub';
      const p = isSub ? planPrice() : data.price;
      plans.forEach(el => el.classList.toggle('is-active', el.dataset.fwMode === mode));
      $$('input[name="selling_plan"]', box).forEach(i => { i.disabled = !isSub; });
      if (priceEl) priceEl.textContent = formatMoney(p);
      if (cmpEl) cmpEl.hidden = !isSub;
      if (perEl) perEl.textContent = `${formatMoney(Math.round(p / servings))} per scoop`;
      if (unitEl && data.unitPrice && data.price) unitEl.textContent = `${formatMoney(Math.round(data.unitPrice * p / data.price))} / ${data.unitLabel}`;
      if (addLabel) addLabel.textContent = isSub ? 'Subscribe' : 'Add to cart';
      if (addPrice) addPrice.textContent = formatMoney(p);
    };
    plans.forEach(el => {
      const r = $('input[type="radio"][name^="fw-mode"]', el);
      r.addEventListener('change', () => { if (r.checked) { mode = r.value; update(); } });
    });
    box.addEventListener('change', e => { if (e.target.name === 'selling_plan') update(); });
    $$('[data-fw-qty]', box).forEach(b => b.addEventListener('click', () => {
      const i = $('input[name="quantity"]', box);
      i.value = Math.max(1, Math.min(12, (+i.value || 1) + +b.dataset.fwQty));
    }));
    if (form && data.available) {
      form.addEventListener('submit', async e => {
        e.preventDefault();
        const btn = $('[data-fw-add-btn]', box);
        btn.setAttribute('aria-disabled', 'true');
        if (msg) msg.textContent = '';
        const item = { id: data.variant, quantity: +($('input[name="quantity"]', box).value || 1) };
        const sel = mode === 'sub' ? $('input[name="selling_plan"]:checked', box) : null;
        if (sel && /^\d+$/.test(sel.value)) item.selling_plan = +sel.value;
        try {
          const res = await fetch(url('/cart/add.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) });
          const json = await res.json();
          if (!res.ok) throw new Error(json.description || json.message || 'Could not add to cart');
          await Cart.open();
        } catch (err) {
          if (msg) msg.textContent = err.message;
        } finally {
          btn.removeAttribute('aria-disabled');
        }
      });
    }
    update();
  });

  /* ---------- cart drawer ---------- */
  const Cart = {
    el: $('[data-fw-drawer]'),
    async fetch() {
      const res = await fetch(url('/cart.js'), { headers: { Accept: 'application/json' } });
      return res.json();
    },
    count(n) {
      $$('[data-fw-cart-count]').forEach(el => { el.textContent = n; el.hidden = n === 0; });
      $$('[data-fw-cart-open]').forEach(b => b.setAttribute('aria-label', `Open cart, ${n} item${n === 1 ? '' : 's'}`));
    },
    render(cart) {
      if (!this.el) return;
      const body = $('[data-fw-cart-items]', this.el), foot = $('[data-fw-cart-foot]', this.el);
      this.count(cart.item_count);
      if (!cart.item_count) {
        body.innerHTML = $('[data-fw-empty-tpl]', this.el).innerHTML;
        foot.hidden = true;
        return;
      }
      body.innerHTML = cart.items.map((it, i) => {
        const img = it.image ? `<img class="fw-line__img" src="${it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2')}" alt="" width="76" height="76" loading="lazy">` : '<span class="fw-line__img"></span>';
        const plan = it.selling_plan_allocation ? `<div class="fw-line__meta">${esc(it.selling_plan_allocation.selling_plan.name)}</div>` : '';
        const variant = it.variant_title && it.variant_title !== 'Default Title' ? `<div class="fw-line__meta">${esc(it.variant_title)}</div>` : '';
        return `<div class="fw-line">${img}<div><div class="fw-line__title">${esc(it.product_title)}</div>${variant}${plan}
          <div class="fw-line__qty"><button type="button" data-fw-line="${i + 1}" data-q="${it.quantity - 1}" aria-label="Decrease">−</button><span>${it.quantity}</span><button type="button" data-fw-line="${i + 1}" data-q="${it.quantity + 1}" aria-label="Increase">+</button></div></div>
          <div class="fw-line__price">${formatMoney(it.final_line_price)}<button class="fw-line__remove" type="button" data-fw-line="${i + 1}" data-q="0">Remove</button></div></div>`;
      }).join('');
      $('[data-fw-cart-total]', this.el).textContent = formatMoney(cart.total_price);
      foot.hidden = false;
    },
    async open() {
      if (!this.el) { location.href = routes.cart; return; }
      this.render(await this.fetch());
      if (!this.el.open) this.el.showModal();
    },
    close() { if (this.el && this.el.open) this.el.close(); }
  };
  const esc = s => String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  FW.cart = Cart;
  $$('[data-fw-cart-open]').forEach(b => b.addEventListener('click', () => Cart.open().catch(() => { location.href = routes.cart; })));
  if (Cart.el) {
    Cart.el.addEventListener('click', async e => {
      if (e.target === Cart.el || e.target.closest('[data-fw-drawer-close]')) { Cart.close(); return; }
      const b = e.target.closest('[data-fw-line]');
      if (!b) return;
      b.disabled = true;
      try {
        const res = await fetch(url('/cart/change.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: +b.dataset.fwLine, quantity: Math.max(0, +b.dataset.q) }) });
        Cart.render(await res.json());
      } catch (err) { b.disabled = false; }
    });
  }

  /* ---------- signup: code reveal + copy ---------- */
  const posted = /[?&]customer_posted=true/.test(location.search);
  if (posted) store.set('fw_signed', '1');
  const signed = store.get('fw_signed') === '1';
  if (signed) {
    $$('.fw-signup').forEach(f => { f.classList.add('is-done'); const c = $('[data-fw-code]', f); if (c) c.hidden = false; });
    $$('.fw-pop__no').forEach(b => { b.textContent = 'Close'; });
  }
  // if the 3D can't start (old device, blocked script), show the product photo instead
  setTimeout(() => { if (!FW.three) document.documentElement.classList.add('fw-no-3d'); }, 9000);
  $$('[data-fw-copy]').forEach(b => b.addEventListener('click', async () => {
    const code = b.dataset.fwCopy, lab = $('[data-fw-copy-label]', b);
    try { await navigator.clipboard.writeText(code); } catch (e) {
      const t = document.createElement('textarea'); t.value = code; document.body.appendChild(t); t.select();
      try { document.execCommand('copy'); } catch (er) {} t.remove();
    }
    if (lab) { lab.textContent = 'Copied!'; setTimeout(() => { lab.textContent = 'Copy'; }, 1800); }
  }));

  /* ---------- pop-up ---------- */
  const pop = $('[data-fw-pop]');
  if (pop && typeof pop.showModal === 'function') {
    const close = () => { if (pop.open) pop.close(); store.set('fw_pop_seen', String(Date.now())); };
    pop.addEventListener('click', e => { if (e.target === pop || e.target.closest('[data-fw-pop-close]')) close(); });
    pop.addEventListener('cancel', () => store.set('fw_pop_seen', String(Date.now())));
    const fromPopup = posted && /fw-signup-popup/.test(location.hash);
    const seen = +store.get('fw_pop_seen') || 0;
    const tooSoon = Date.now() - seen < 7 * 864e5;
    const design = window.Shopify && window.Shopify.designMode;
    if (fromPopup) {
      pop.showModal();
    } else if (!signed && !tooSoon && !design) {
      let shown = false;
      const show = () => {
        if (shown || pop.open || document.querySelector('dialog[open]')) return;
        shown = true; pop.showModal(); store.set('fw_pop_seen', String(Date.now()));
      };
      setTimeout(show, (+pop.dataset.delay || 10) * 1000);
      document.addEventListener('mouseout', e => { if (!e.relatedTarget && e.clientY < 8 && scrollY > 400) show(); });
    }
  }
})();